import { render, staticRenderFns } from "./Choice.vue?vue&type=template&id=61d74dbb&scoped=true&"
import script from "./Choice.vue?vue&type=script&lang=js&"
export * from "./Choice.vue?vue&type=script&lang=js&"
import style0 from "./Choice.vue?vue&type=style&index=0&id=61d74dbb&lang=scss&scoped=true&"
import style1 from "./Choice.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d74dbb",
  null
  
)

component.options.__file = "Choice.vue"
export default component.exports